import React, { useState, useEffect } from 'react';
import { Accordion, Card, Spinner, Tooltip } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import { cloneDeep, isEmpty } from 'lodash';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import Loader from '../../../Components/Utility/Loader/Loader';
import * as action from '../Store/SystemMasters.action';
import DropdownCard from './DropdownCard';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';

function CustomAttrSave(isCustomAttr) {
  return isCustomAttr ? <Spinner animation="border" /> : <i className="icon-Tick-1 f-24" />;
}

function MultiCustomAttribute({ OpenReArrangeFunction }) {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const [CustomAttrBtnDisable, setCustomAttrBtnDisable] = useState(false);
  const [isCustomAttrUnique, setIsCustomAttrUnique] = useState(true);
  const [buttonDownCustomAttr, setButtonDownCustomAttr] = useState(true);
  const [isLoadingCustomAttr, setIsLoadingCustomAttr] = useState(false);
  const [showCustomAttr, setShowCustomAttr] = useState(false);
  const [deleteId, setDeleteId] = useState('');
  const [activeInactiveID, setActiveInactiveID] = useState('');
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [isLoadingConf, setIsLoadingConf] = useState(false);
  const [showConfirmationAD, setShowConfirmationAD] = useState(false);
  const [openList, setOpenList] = useState([]);
  const [isCustomAttr, setIsCustomAttr] = useState(false);
  const [optionIds, setOptionDeleteId] = useState('');
  const [isUniqCustomAttrId, setIsUniqCustomAttrId] = useState([]);
  const [isValueUnique, setIsValueUnique] = useState(false);
  const [uniqueValueId, setIsUniqValueId] = useState(true);

  const [state, setState] = useState({
    dropDownTextList: [],
    modifiedList: [],
    activeType: {},
    dropdownOptionList: [],
  });

  const reducer = useSelector((estate) => estate);
  const {
    SystemMastersDetails,
    UserDetails: { userInfo },
  } = reducer;

  const loggedInUserId = userInfo.userId;
  const { pcpCustomAttribute } = SystemMastersDetails;
  const MasterAddEditAccess = true;
  const MasterDeleteAccess = true;

  const labelTmpObj = {
    keyName: null,
    isLable: true,
    type: null,
    isActive: true,
    isChecked: true,
    _id: '',
    isEmpty: false,
    isNew: true,
    productType: [],
  };
  const valueTmpObj = {
    keyName: null,
    aliasName: '',
    isLable: false,
    type: null,
    lableId: null,
    isActive: true,
    isChecked: true,
    _id: '',
    isEmpty: false,
    isNew: true,
    productType: [],
  };

  const getmultiCustomAttribute = async () => {
    await Promise.all([dispatch(action.getMultiCustomAttribute()), dispatch(action.getPCTypesDetails({ tier: 'Tier1' }, true))]);
  };

  const callApi = async () => {
    if (buttonDownCustomAttr) {
      getmultiCustomAttribute();
    }
    setButtonDownCustomAttr(!buttonDownCustomAttr);
    setIsLoadingCustomAttr(true);
    setShowCustomAttr(buttonDownCustomAttr);
    setIsLoadingCustomAttr(false);
  };

  const handleValueChanged = (event, i, parentIndex) => {
    const { name, value } = event.target;
    const newValue = value?.trimStart();
    const valueText = [...state.modifiedList];

    if (name === 'aliasName') {
      valueText[parentIndex].values[i] = {
        ...valueText[parentIndex].values[i],
        aliasName: newValue,
      };
    } else {
      valueText[parentIndex].values[i] = {
        ...valueText[parentIndex].values[i],
        keyName: newValue,
        isEmpty: newValue === '',
      };
    }

    setState((prevState) => ({
      ...prevState,
      modifiedList: valueText,
    }));
    setIsValueUnique(true);
    setIsUniqValueId([]);

    const duplicateValues = [];
    const duplicateIndices = [];

    valueText[parentIndex].values.forEach((val1, idx1) => {
      valueText[parentIndex].values.forEach((val2, idx2) => {
        if (val1.keyName === val2.keyName && idx1 !== idx2 && val1.keyName !== '') {
          duplicateValues.push(val1);
          duplicateIndices.push(idx2);
        }
      });
    });

    if (!isEmpty(duplicateValues)) {
      setIsUniqValueId([...duplicateIndices]);
    }
    setIsValueUnique(isEmpty(duplicateValues));

    let disableValueBtn = false;
    valueText[parentIndex].values.forEach((valueElement) => {
      if (isEmpty(valueElement?.keyName?.trim())) {
        disableValueBtn = true;
      }
    });
    setCustomAttrBtnDisable(disableValueBtn);
  };

  const btnCall = () => {
    if (buttonDownCustomAttr === false) {
      return <i className="icon-new-down-arrow-icon icon-inverse f-24" />;
    }
    return <i className="icon-new-down-arrow-icon f-24" />;
  };

  const addCustomAttr = async () => {
    if (state?.modifiedList?.length >= 10) {
      toasterMsg(t('CUSTOM_ATTRIBUTES.MAX_ENTRIES'), 'danger');
    } else if (state.activeType !== null) {
      const tempObj = cloneDeep(labelTmpObj);
      tempObj.type = state.activeType.value;
      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList, tempObj],
      }));
    }
  };

  const renderTooltipActiveInactive = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('CUSTOM_ATTRIBUTES.ACTIVE_INACTIVE')}
    </Tooltip>
  );

  const renderTooltipDelete = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('CUSTOM_ATTRIBUTES.DELETE')}
    </Tooltip>
  );
  const renderTooltipAddOption = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('CUSTOM_ATTRIBUTES.ADD_OPTION')}
    </Tooltip>
  );

  const renderTooltipAddValue = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      {t('CUSTOM_ATTRIBUTES.ADD_VALUE')}
    </Tooltip>
  );

  const handleCheckboxCA = (e) => {
    const id = e?.target?.id.split('_')[2];
    const list = state.modifiedList?.map((element) => {
      if (element?._id === id) {
        element.isChecked = e?.target?.checked;
      }
      return element;
    });
    setState((oldData) => ({ ...oldData, modifiedList: [...list] }));
  };

  const handleChanged = (event, i) => {
    const freeTextDropdownData = [...state.modifiedList];
    freeTextDropdownData[i] = {
      ...freeTextDropdownData[i],
      keyName: event.target.value?.trimStart(),
      isEmpty: event.target.value === '',
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
    setIsCustomAttrUnique(true);
    setIsUniqCustomAttrId([]);
    const arr = [];
    const arrIndex = [];
    freeTextDropdownData.forEach((ele, ind) => {
      freeTextDropdownData.forEach((objs, index) => {
        if (ele.keyName === objs.keyName && ind !== index) {
          arr.push(ele);
          arrIndex.push(index);
        }
      });
    });

    if (!isEmpty(arr)) {
      setIsUniqCustomAttrId([...arrIndex]);
    }
    setIsCustomAttrUnique(isEmpty(arr));
    let disableCustomAttr = false;
    freeTextDropdownData.forEach((CustomAttrElement) => {
      if (isEmpty(CustomAttrElement?.keyName?.trim())) {
        disableCustomAttr = true;
      }
    });
    setCustomAttrBtnDisable(disableCustomAttr);
  };

  const activeInactiveClicked = (id, valueId) => {
    setShowConfirmationAD(true);
    setActiveInactiveID(id);
    setOptionDeleteId(valueId || null);
  };
  const activeInactiveConfirmed = async () => {
    setIsLoadingConf(true);
    let c3 = {};
    state.modifiedList.forEach((ele) => {
      if (ele._id === activeInactiveID && !optionIds) {
        ele.isActive = !ele.isActive;
        const data = {
          ...ele,
          loggedInUserId,
          customId: activeInactiveID,
        };
        c3 = data;
      } else if (ele?.values?.length > 0 && optionIds) {
        const valueEle = ele.values.find((eleValue) => eleValue._id === optionIds);
        if (valueEle) {
          valueEle.isActive = !valueEle.isActive;
          const dataValue = {
            ...valueEle,
            optionIds,
            customId: activeInactiveID,
            loggedInUserId,
          };
          c3 = dataValue;
        }
      }
    });
    await dispatch(action.setActiveInactiveMultiCustomAttribute(c3, t));
    setIsLoadingConf(false);
    setShowConfirmationAD(false);

    setState((prevState) => ({
      ...prevState,
      modifiedList: [...state.modifiedList],
    }));
  };

  const addValueForLabel = (id, index) => {
    const tempObj = cloneDeep(valueTmpObj);
    tempObj.lableId = id;
    tempObj.type = 'dropdown';

    const freeTextDropdownData = [...state.modifiedList];

    const existingValue = freeTextDropdownData[index].values;
    existingValue?.push(tempObj);

    freeTextDropdownData[index] = {
      ...freeTextDropdownData[index],
      values: existingValue || [tempObj],
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));
  };

  const handleDelete = (id, parentI) => {
    if (typeof id === 'number' || id === '') {
      if (typeof parentI === 'number') {
        state.modifiedList[parentI].values.splice(id, 1);
      } else {
        state.modifiedList.splice(id, 1);
      }

      state.modifiedList.forEach((CustomAttrElement) => {
        if (isEmpty(CustomAttrElement?.keyName?.trim()) && CustomAttrElement.isNew) {
          setCustomAttrBtnDisable(true);
        } else {
          setCustomAttrBtnDisable(false);
        }
      });

      setIsCustomAttrUnique(true);
      setIsUniqCustomAttrId([]);

      setState((prevState) => ({
        ...prevState,
        modifiedList: [...state.modifiedList],
      }));
    } else {
      const selectedParent = parentI !== undefined ? state.modifiedList[parentI]?._id || '' : '';
      const selectedOptionId = parentI !== undefined ? state.modifiedList[parentI]?.values?.find((ele) => ele._id === id)?._id || '' : '';

      setDeleteId(selectedParent || id);
      setOptionDeleteId(selectedOptionId);
      setShowConfirmation(true);
    }
  };

  const deleteConfirmed = async () => {
    setIsLoadingConf(true);
    const customAttributePara = {
      loggedInUserId,
      customBomAttributeId: deleteId,
      optionIds: optionIds || null,
    };
    await dispatch(action.deleteMultiCustom(customAttributePara, t));
    setIsLoadingConf(false);
    setShowConfirmation(false);
    setDeleteId(null);
    setOptionDeleteId(null);

    setState((prev) => ({
      ...prev,
      dropDownTextList: [],
      modifiedList: [],
    }));
    getmultiCustomAttribute();
  };

  const onDropSelectionChange = (selectedOptions, index) => {
    const freeTextDropdownData = [...state.modifiedList];

    freeTextDropdownData[index] = {
      ...freeTextDropdownData[index],
      productType: selectedOptions,
      isEmpty: isEmpty(selectedOptions),
    };

    setState((prevState) => ({
      ...prevState,
      modifiedList: freeTextDropdownData,
    }));

    const disableCustomAttr = freeTextDropdownData.some((attr) => isEmpty(attr?.keyName?.trim()));
    setCustomAttrBtnDisable(disableCustomAttr);
  };

  const renderDropdownCard = (card, index) => {
    return (
      <DropdownCard
        key={card?.id}
        index={index}
        item={card}
        handleChanged={handleChanged}
        renderTooltipAddValue={renderTooltipAddValue}
        addValueForLabel={addValueForLabel}
        handleValueChanged={handleValueChanged}
        renderTooltipActiveInactive={renderTooltipActiveInactive}
        activeInactiveClicked={activeInactiveClicked}
        renderTooltipDelete={renderTooltipDelete}
        renderTooltipAddOption={renderTooltipAddOption}
        handleDelete={handleDelete}
        openList={openList}
        setOpenList={setOpenList}
        handleCheckboxCA={handleCheckboxCA}
        masterAddEditAccess={MasterAddEditAccess}
        masterDeleteAccess={MasterDeleteAccess}
        onDropSelectionChange={onDropSelectionChange}
        isUniqueId={isUniqCustomAttrId}
        uniqueValueId={uniqueValueId}
        isValueUnique={isValueUnique}
      />
    );
  };

  useEffect(() => {
    if (!isEmpty(pcpCustomAttribute)) {
      setState((prevState) => ({
        ...prevState,
        dropDownTextList: pcpCustomAttribute,
        modifiedList: pcpCustomAttribute,
      }));
    }
  }, [pcpCustomAttribute]);

  const saveFreeTextDropdown = async () => {
    try {
      setIsCustomAttr(true);
      const allData = state?.modifiedList || [];

      if (isEmpty(allData)) {
        setIsCustomAttr(false);
        return;
      }

      const emptyFields = allData.filter(
        (item) => !item.keyName || item.keyName.trim() === '' || ((!item?.productType || item?.productType?.length === 0) && !item.lableId),
      );

      const emptyValueFields = allData.filter((item) => item.values?.some((value) => !value.keyName || value.keyName.trim() === ''));

      if (!isEmpty(emptyFields) || !isEmpty(emptyValueFields)) {
        const updatedList = state.modifiedList.map((item) => ({
          ...item,
          isEmpty:
            emptyFields.some((empty) => empty.keyName === item.keyName || empty.productType?.length === 0) ||
            emptyValueFields.some((empty) => empty._id === item._id),
        }));

        if (emptyFields.length > 0 || emptyValueFields.length > 0) {
          toasterMsg(t('MASTERS.ALL_FIELDS_REQUIRED'), 'danger');
        }

        setState((prevState) => ({
          ...prevState,
          modifiedList: updatedList,
        }));

        setIsCustomAttr(false);
        return;
      }

      const formattedData = allData.map((item) => ({
        ...item,
        name: item.keyName.trim(),
        ...(item.lableId ? { productType: null } : {}),
      }));

      const custAttrParams = {
        keyNames: JSON.stringify(formattedData),
      };

      const res = await dispatch(action.saveMultiAttribute(custAttrParams, t));
      if (res.code === 200) {
        setState((prevState) => ({
          ...prevState,
          modifiedList: [],
          dropDownTextList: [],
          dropdownOptionList: [],
        }));
        getmultiCustomAttribute();
      }
    } catch (error) {
      console.error('Error in saveFreeTextDropdown:', error);
    } finally {
      setIsCustomAttr(false);
    }
  };

  return (
    <>
      <Accordion className="mb-4 master-accordian custom-attribute-master">
        <Card className="card">
          <Card.Header>
            <div className="title-container">
              <p>{t('MULTI_CUSTOM_ATTRIBUTES.MULTI_CUSTOM_ATTRIBUTES_TITLE')}</p>
            </div>
            <div className={!MasterAddEditAccess ? 'action-title-btns single-btn' : 'action-title-btns'}>
              <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.REARRANGE_TOOLTIP')}>
                <button
                  type="button"
                  onClick={() => OpenReArrangeFunction('multiCustomAttribute')}
                  className="btn d-inline-flex mr-16 p-0"
                  disabled={CustomAttrBtnDisable || !isCustomAttrUnique || !pcpCustomAttribute?.length || uniqueValueId?.length}
                  aria-label="Rearrange"
                >
                  <span className="icon-Rearrange text-grey  f-24" />
                </button>
              </CustomTooltip>

              <CustomTooltip tooltipText={!buttonDownCustomAttr ? t('CUSTOM_ATTRIBUTES.CLOSE') : t('CUSTOM_ATTRIBUTES.OPEN')}>
                <button className="btn d-inline-flex p-0" onClick={() => callApi()} type="button">
                  {btnCall()}
                </button>
              </CustomTooltip>
            </div>
          </Card.Header>
          {showCustomAttr &&
            (isLoadingCustomAttr ? (
              <Loader />
            ) : (
              <Card.Body className="multi-body">
                <div className="common-scrollbar flex-fill">
                  {Array.isArray(state?.modifiedList) &&
                    !isEmpty(state?.modifiedList) &&
                    state?.modifiedList?.map((ele, index) => {
                      return renderDropdownCard(ele, index);
                    })}
                </div>
                {MasterAddEditAccess && (
                  <CustomTooltip tooltipText={t('CUSTOM_ATTRIBUTES.ADD_TOOLTIP')}>
                    <button
                      type="button"
                      onClick={() => addCustomAttr()}
                      className="btn btn-outline ml-auto mr-0 mt-16 p-0"
                      disabled={CustomAttrBtnDisable || !isCustomAttrUnique}
                      aria-label="Add"
                    >
                      <span className="icon-Add text-grey  f-24" />
                    </button>
                  </CustomTooltip>
                )}
                {MasterAddEditAccess && (
                  <div className="section-custom-save">
                    <button
                      aria-label="Save"
                      type="button"
                      className="btn  p-0"
                      onClick={saveFreeTextDropdown}
                      disabled={CustomAttrBtnDisable || !isCustomAttrUnique || uniqueValueId?.length}
                    >
                      {CustomAttrSave(isCustomAttr)}
                    </button>
                  </div>
                )}
              </Card.Body>
            ))}
        </Card>
      </Accordion>
      {showConfirmation && (
        <ConfirmationPopup
          onOpen={showConfirmation}
          onConfirm={() => deleteConfirmed()}
          title={t('CUSTOM_ATTRIBUTES.DELETE_CONFIRM_TITLE')}
          message={t('CUSTOM_ATTRIBUTES.DELETE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmation(!showConfirmation);
          }}
          loading={isLoadingConf}
        />
      )}
      {showConfirmationAD && (
        <ConfirmationPopup
          onOpen={showConfirmationAD}
          onConfirm={() => activeInactiveConfirmed()}
          title={t('CUSTOM_ATTRIBUTES.ACTIVE_DEACTIVATE_CONFIRM_TITLE')}
          message={t('CUSTOM_ATTRIBUTES.ACTIVE_DEACTIVATE_CONFIRM_MESSAGE')}
          toggle={() => {
            setShowConfirmationAD(!showConfirmationAD);
          }}
          loading={isLoadingConf}
        />
      )}
    </>
  );
}

export default MultiCustomAttribute;
